module.exports = __webpack_public_path__ + "static/media/ao-lyd.e0c873e6.mp3";